// 하나은행 SMS 입출금통지 등록 안내(2026-07-03 오너 라이브 실측). Type B: 인증코드 없음.
import type { GuideStep } from './guideStepPrimitives';
import { GATEWAY_NUMBER_DISPLAY } from './wooriGuide';

export const HANA_REGISTER_STEPS: GuideStep[] = [
  { title: '하나원큐 앱 → 메뉴 → 설정 → 알림 설정' },
  { title: '입출금 문자 알림 → 신청하기' },
  { title: '알림항목 "전체"(또는 "입금"), 알림금액 "전액", 알림시간 "실시간통지"' },
  {
    title: `"휴대폰번호"에 아래 셀러헬퍼 번호 입력 후 [휴대폰번호 추가]를 꼭 누르기`,
    detail: `내 휴대폰 번호가 아니라 ${GATEWAY_NUMBER_DISPLAY}를 입력해주세요.`,
    detailTone: 'danger',
  },
  { title: '이용료 결제계좌 선택 후 [다음] → 신청 완료' },
];

export const HANA_NOTIFY_OPTIONS: GuideStep[] = [
  {
    title: '알림금액: "전액"',
    titleTone: 'danger',
    detail: '1원 인증 문자를 받으려면 "전액"이어야 해요(설정금액 금지).',
    detailTone: 'danger',
  },
  { title: '알림항목: "전체" 또는 "입금"' },
  { title: '알림시간: "실시간통지"' },
];
